import { useEffect, useState } from 'react';
import type { GranularityOption } from '../../accounts/GranularityToggle';

function loadChoice<T extends string>(storageKey: string, options: GranularityOption<T>[]): T {
    try {
        const raw = sessionStorage.getItem(storageKey);
        return options.find((option) => option.key === raw)?.key ?? options[0].key;
    } catch {
        return options[0].key;
    }
}

// A toggle's choice for this tab session; defaults to the first option.
export function useStoredChoice<T extends string>(
    storageKey: string,
    options: GranularityOption<T>[]
) {
    const [choice, setChoice] = useState(() => loadChoice(storageKey, options));
    useEffect(() => {
        try {
            sessionStorage.setItem(storageKey, choice);
        } catch {
            // Blocked storage only costs remembering the toggle.
        }
    }, [choice, storageKey]);
    return [choice, setChoice] as const;
}
